import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { DatePicker } from "antd";
import moment from "moment";

class RangePicker extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			searchValue: "",
		};
	}

	componentDidMount() {
		this.props.setKeyFilterSelected();
    	if (this.props.defaultRange) {
        this.props.addFilter({
          startDate: moment(this.props.defaultRange[0])
            .startOf("day")
            .toDate(),
          endDate: moment(this.props.defaultRange[1])
            .endOf("day")
            .toDate()
        });
      }
	}

	disabledDate = current => {
		if (this.props.maxDate && this.props.minDate) {
			return (
				current > moment(this.props.maxDate).endOf("day") ||
				current < moment(this.props.minDate).startOf("day")
			);
		}
		// Can only select days before today
		return current > moment().endOf("day");
	};
	
	onChange(dates = []) {
		if (dates.length === 0) {
			this.props.addFilter();
			return;
		} else if (dates.length < 2) {
			return;
		}

		this.props.addFilter({
			startDate: dates[0]
				.hour(0)
				.minute(0)
				.second(0)
				.toDate(),
			endDate: dates[1]
				.hour(23)
				.minute(59)
				.second(59)
				.toDate(),
		});
	}

	render() {
		const pickerProps = {
      onChange: dates => this.onChange(dates),
      placeholder: ["Début", "Fin"],
      format: "DD/MM/YYYY",
      locale: DatePicker.locale,
      disabledDate: this.disabledDate,
      ...this.props
    };
    if (this.props.defaultRange) {
      pickerProps.defaultValue = [moment(this.props.defaultRange[0]), moment(this.props.defaultRange[1])];
    }

		return <DatePicker.RangePicker {...pickerProps} />;
	}
}

RangePicker.propTypes = {
	onChange: PropTypes.func,
};

export default RangePicker;



// WEBPACK FOOTER //
// src/components/rangePicker/rangePicker.js